<template>
    <div>
        <template v-if="!credito.error_credito_disponible && !credito.message">
            <div class="row">
                <div class="col-sm-4 offset-sm-8"><button class="btn btn-bpb-primary" @click="ver_tabla=!ver_tabla">{{ !ver_tabla ? 'Tabla de amortización' : 'Cerrar tabla de amortización'}}</button></div>
            </div>
            <template v-if="!ver_tabla">
            <div class="row text-center mb-4">
                <div class="col-sm-12 col-md-6 offset-md-3 align-self-center">
                    <div class="card bpb-card">
                        <div class="card-body">
                            <h4 class="card-title chapter">Información para el pago</h4>
                            <h6 class="card-subtitle mb-2 text-muted">La información vigente de este mes</h6>
                            <small>Fecha de corte</small>
                            <h5>{{ $moment(credito.creditCutoffDate).format('DD-MM-YYYY') }}</h5>
                            <small>Saldo al corte</small>
                            <h5>${{ $helper.moneyFormat(credito.creditCutoffBalance) }}</h5>
                            <small>Pago requerido</small>
                            <h3>${{ $helper.moneyFormat(credito.creditIdealPayment) }}</h3>
                            <small>Fecha límite de pago</small>
                            <h3 v-html="credito.creditDueDate.indexOf('.') >= 0 ? $moment(credito.creditDueDate).format('DD-MM-YYYY') : credito.creditDueDate"></h3>
                            <div v-if="credito.bankAccountBank && credito.bankAccountNumber">
                                <small>Cuenta bancaria dónde pagar</small>
                                <h5><b>{{ credito.bankAccountBank }} : {{ credito.bankAccountNumber }}</b></h5>
                                <small>Referencia</small>
                                <h5>{{ credito.bankAccountReference }}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center mb-4">
                <div class="col-sm-12 col-md-6 offset-md-3 align-self-center">
                    <div class="card bpb-card">
                        <div class="card-body">
                            <h4 class="card-title chapter">Detalles de mi Crédito BpB</h4>
                            <h6 class="card-subtitle mb-2 text-muted">Los generales del Crédito</h6>
                            <small>Tipo de crédito</small>
                            <h5>{{ credito.contractProduct  }}</h5>
                            <small>Número de crédito</small>
                            <h5>{{ credito.contractFolio }}</h5>
                            <small>Monto del crédito</small>
                            <h5>${{ $helper.moneyFormat(credito.importe_solicitado) }}</h5>
                            <small>Plazo</small>
                            <h5>{{ credito.plazo }} años</h5>
                            <small>Mensualidad</small>
                            <h5>{{ credito.creditPeriod }} de {{ credito.creditTotalPeriods }}</h5>
                            <small>Saldo anterior</small>
                            <h5>${{ $helper.moneyFormat(credito.creditPreviousBalance) }}</h5>
                            <div v-if="credito.creditLastPayment != '-' && $moment(credito.creditLastPayment).isAfter('2020-02-01')">
                                <small>Fecha de último pago</small>
                                <h5>{{ $moment(credito.creditLastPayment).format('DD-MM-YYYY') }}</h5>
                            </div>
                            <div v-if="credito.pagos.monto_ultimo_pago">
                                <small>Monto de último pago realizado</small>
                                <h5>${{ $helper.moneyFormat(credito.pagos.monto_ultimo_pago) }}</h5>
                            </div>      
                        </div>
                    </div>
                </div>
            </div>
            </template>
            <div v-if="ver_tabla" class="container-fluid">
                <div class="row mb-4">
                    <h2 class="col-sm-12">Tabla de amortización</h2>
                </div>
                <div v-for="amortizacion in credito.amortizacion" class="row mb-4 table-amortization">
                    <div class="col-sm-12">
                        <div class="row">
                            <div class="col-sm-2">Amortización: {{ amortizacion.amortization }}</div>
                            <div class="col-sm-3">Fecha de corte: {{ amortizacion.cutoffDate }}</div>
                            <div class="col-sm-3">Fecha de vencimiento: {{ amortizacion.dueDate }}</div>
                            <div class="col-sm-2">Capital: ${{ $helper.moneyFormat(amortizacion.principal) }}</div>
                            <div class="col-sm-2">Interés: ${{ $helper.moneyFormat(amortizacion.interest) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <template v-if="credito.message">
            <div class="row">
                <div class="col">
                    <h3 class="text-right">{{ credito.message }}</h3>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col">
                    <p>{{ credito.error }}</p>
                </div>
            </div>
            </template>

            <template v-if="credito.error_credito_disponible">
            <div class="row mt-4">
                <div class="col">
                    <p class="text-center"><img src="/info.png" alt=""></p>
                    <p class="text-center mt-4">Estimado Cliente; cuando se genere el corte del primer ciclo de su crédito podrás acceder a la información</p>
                </div>
            </div>
            </template>
        </template>
        <!-- <div class="d-flex col-md-4 offset-md-8">
            <a type="button" class="btn btn-bpb-primary btn-block" data-toggle="modal" data-target="#staticBackdrop">
                Descargar estado de cuenta
            </a>
        </div> -->
        <!-- Modal -->
        <!-- <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">Estado de cuenta</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container">
                            <div class="">
                                <small>Crédito</small>
                                <h2>{{ credito.no_credito }}</h2>
                            </div>
                            <hr />
                            <div class="">
                                <h4>Período de consulta</h4>
                                <div class="form-check">
                                    <input v-model="tipo_estado_cuenta" class="form-check-input" type="radio" name="tipo_estado_cuenta" id="ultimo_estado_cuenta" value="ultimo_estado_cuenta" data-estados="estados_de_cuenta">
                                    <label class="form-check-label" for="ultimo_estado_cuenta">
                                        Último estado de cuenta <br>
                                        <small>Fecha corte: {{ $moment(credito.documentos[0].creacion).format('DD-MM-YYYY') }}</small>
                                    </label>
                                </div>
                                <br />
                                <div>
                                    <div class="form-check">
                                        <input v-model="tipo_estado_cuenta" class="form-check-input" type="radio" name="tipo_estado_cuenta" id="otro_estado_cuenta" value="otro_estado_cuenta" data-estados="estados_de_cuenta">
                                        <label class="form-check-label" for="otro_estado_cuenta">
                                            Otros estados de cuenta
                                        </label>
                                    </div>
                                    <div v-if="tipo_estado_cuenta == 'otro_estado_cuenta'" class="col-sm-12">
                                        <select ref="estado_cuenta_select" class="custom-select" id="estado_cuenta_select">
                                            <option value="0">Selecciona el Período</option>
                                            <option v-for="(documento, index) in credito.documentos" :key="index" :value="documento.id">{{ $moment(documento.creacion).format('DD-MM-YYYY') }}</option>
                                        </select>
                                    </div>
                                </div>
                                <br />
                                <div class="form-check">
                                    <input v-model="tipo_estado_cuenta" class="form-check-input" type="radio" name="tipo_estado_cuenta" id="todos_estados_cuenta" value="todos_estados_cuenta" data-estados="estados_de_cuenta">
                                    <label class="form-check-label" for="todos_estados_cuenta">
                                        Descargar todos los estados de cuenta
                                    </label>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="col-sm-12 d-flex justify-content-center">
                            <div class="col-sm-4">
                                <button type="button" class="btn btn-bpb-invested btn-block" data-dismiss="modal">Cancelar</button>
                            </div>
                            <div class="col-sm-4">
                                <button type="button" class="btn btn-bpb-primary btn-block" @click="descargar_estadocuenta">Descargar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script type="text/javascript">
import api from '@/api/clientes'

export default {
    props: {
        credito: {
            type: Object,
            default: () => ({
                id: null,
                cliente_id: null,
                no_credito: null,
                importe_solicitado: null,
                importe_seleccionado: null,
                importe_pre_autorizado: null,
                acepto_importe_pre_autorizado: null,
                plazo: null,
                descripcion_solicitud: null,
                promotor_id: null,
                acepta_politicas_privacidad: null,
                descripcion_giro_negocio: null,
                descripcion_politicas: null,
                destino_credito_ejercido: null,
                created_at: null,
                updated_at: null,
                ejercido: {
                    id: null,
                    cliente_id: null,
                    credito_id: null,
                    monto_ejercido: null,
                    numero_comite: null,
                    tasa: null,
                    aforo: null,
                    fecha_comite: null,
                    fecha_formalizacion: null,
                    fecha_escriturarpp: null,
                    notario: null,
                    valor_avaluo: null,
                    garantiaejercido_id: null,
                    tipo_garantia_ejercido: null,
                    tipocredito_id: null,
                    tipo_credito: null,
                    plazo_otorgado: null,
                    comision_apertura: null,
                    observaciones_ejercido: null,
                    monto_retiro: null,
                    monto_autorizado_comite: null,
                    estatus: null,
                    entidad_federativa: null,
                    fecha_pago_avaluo: null,
                    fecha_asignacion_notaria: null,
                    tipo_negocio: null,
                    created_at: null,
                    updated_at: null
                },
                pagos: {
                    pago_minimo: null,
                    plazo: null,
                    recibos_emitidos: null,
                    referencia_concepto_pago: null,
                    fecha_ultimo_pago: null,
                    fecha_ultimo_pago_periodo: null
                }
            })
        }
    },
    data: () => ({
        otros_estados: false
        ,tipo_estado_cuenta: 'ultimo_estado_cuenta'
        ,estado_cuenta_seleccionado: 0
        ,ver_tabla: false
    }),
    // mounted: function() {
    //     this.$log.info('fecha: ',this.credito.creditDueDate.indexOf('.'));
    // },
    methods: {
    	toJson: function(obj) {
            return encodeURI(JSON.stringify(obj));
        }
        ,descargar_estadocuenta: async function() {
            let data;
            let nombre;
            try {
                switch(this.tipo_estado_cuenta) {
                    case 'ultimo_estado_cuenta':
                        data = (await api.descargar_estado_cuenta(this.credito.documentos[0].id)).data;
                        nombre = this.credito.documentos[0].creacion;
                        this.generar_link(data, nombre);
                        break;
                    case 'otro_estado_cuenta':
                        let input = this.$refs.estado_cuenta_select;
                        this.$log.info('id',input.value);
                        data = (await api.descargar_estado_cuenta(input.value)).data;
                        nombre = input.options[input.selectedIndex].text;
                        this.generar_link(data, nombre);
                        break;
                    case 'todos_estados_cuenta':
                        await api.descargar_estado_cuenta_credito(this.credito.id);

                        this.$swal('Exito!','Se procesarán las facturas para generar un solo archivo, en breve recibirás un email con el link para descargar tus facturas');
                        break;
                }
            }catch(e) {
                this.$log.info('Err', e);
                this.$swal('Error','Error al descargar las facturas: '+e.message,'error');
            }
        }
        ,generar_link: function(data, name) {
            let urlFile = window.URL.createObjectURL(data);

            let link = document.getElementById('dynamicDownloadFile');

            if (!link) {
                link = document.createElement('a');
                link.href = urlFile;
                link.id = 'dynamicDownloadFile';
                link.setAttribute('download',`${name}.zip`);
                document.body.appendChild(link);
            }

            link.click();
        }
    }
}
</script>

<style lang="scss">
    .table-amortization {
        .col-sm-2 {
            padding: 2px 5px;
        }
    }

    .table-amortization:nth-child(2n+0) {
        background-color: #E6E6E6;
    }
    .bpb-card{
        width: auto;
    }
    .chapter{
        color: #1561d3;
    }
</style>